import { Spin } from 'antd';
import { Suspense } from 'react';
import { lazyRoute } from './lazy-route';

const CustomFormsPage = lazyRoute(() => import('pages/custom-forms/custom-forms.container'));

const CustomForms = () => (
  <Suspense fallback={<Spin fullscreen />}>
    <CustomFormsPage />
  </Suspense>
);

export default CustomForms;
